// src/components/pipsCreatureKeeper/Tutorial.tsx
import { logger } from '../../../utils/logger';



import React, { useState, useEffect } from 'react';

import {

  IonModal,

  IonHeader,

  IonToolbar,

  IonTitle,

  IonContent,

  IonButton,

  IonButtons,

  IonIcon,

  IonCard,

  IonCardContent,

  IonProgressBar

} from '@ionic/react';

import { arrowBack, arrowForward } from 'ionicons/icons';

import { TUTORIAL_STEPS } from '../../../constants/tutorialSteps';



import './Tutorial.css';



interface TutorialProps {

  isOpen: boolean;

  onComplete: () => void;

  onSkip?: () => void;

}



const Tutorial: React.FC<TutorialProps> = ({ isOpen, onComplete, onSkip }) => {

  const [currentStep, setCurrentStep] = useState(0);



  useEffect(() => {

    if (isOpen) {

      logger.log('Ã°Å¸â€œâ€“ Tutorial opened, steps:', TUTORIAL_STEPS.length);

      logger.log('Ã°Å¸â€œâ€ž Current step:', currentStep);

    }

  }, [isOpen, currentStep]);



  const handleNext = () => {

    const isLastStep = currentStep === TUTORIAL_STEPS.length - 1;



    logger.log('handleNext called:', {

      currentStep,

      totalSteps: TUTORIAL_STEPS.length,

      isLastStep

    });



    if (isLastStep) {

      logger.log('Ã¢Å“â€¦ Last step - calling onComplete');

      handleComplete();

    } else {

      logger.log('Ã¢Å¾Â¡Ã¯Â¸Â Moving to next step:', currentStep + 1);

      setCurrentStep(prev => prev + 1);

    }

  };



  const handleBack = () => {

    if (currentStep > 0) {

      logger.log('Ã¢Â¬â€¦Ã¯Â¸Â Moving to previous step:', currentStep - 1);

      setCurrentStep(prev => prev - 1);

    }

  };



  const handleComplete = () => {

    logger.log('Ã¢Å“â€¦ handleComplete called');

    setCurrentStep(0);

    onComplete();

  };



  const handleSkipClick = () => {

    logger.log('Ã¢ÂÂ­Ã¯Â¸Â Tutorial skipped');

    setCurrentStep(0);

    if (onSkip) {

      onSkip();

    } else {

      onComplete();

    }

  };



  // Safety check

  if (!TUTORIAL_STEPS || TUTORIAL_STEPS.length === 0) {

    logger.error('Ã¢ÂÅ’ TUTORIAL_STEPS is empty or undefined!');

    return (

      <IonModal isOpen={isOpen} onDidDismiss={handleComplete}>

        <IonHeader>

          <IonToolbar>

            <IonTitle>Error</IonTitle>

          </IonToolbar>

        </IonHeader>

        <IonContent className="ion-padding">

          <p>Tutorial content is not available. Please check console for errors.</p>

          <IonButton expand="block" onClick={handleComplete}>

            Continue

          </IonButton>

        </IonContent>

      </IonModal>

    );

  }



  const progress = (currentStep + 1) / TUTORIAL_STEPS.length;

  const currentStepData = TUTORIAL_STEPS[currentStep];

  const isLastStep = currentStep === TUTORIAL_STEPS.length - 1;



  return (

    <IonModal

      isOpen={isOpen}

      backdropDismiss={false}

      className="tutorial-modal"

      onDidDismiss={() => {

        logger.log('Modal dismissed');

      }}

    >

      <IonHeader>

        <IonToolbar color="success">

          <IonTitle>🐱 Pip's Creature Keeper</IonTitle>

          <IonButtons slot="end">

            {onSkip && !isLastStep && (

              <IonButton onClick={handleSkipClick} color="dark" fill="solid">

                Skip

              </IonButton>

            )}

          </IonButtons>

        </IonToolbar>

        <IonProgressBar value={progress} color="success" />

      </IonHeader>



      <IonContent className="tutorial-content" style={{ '--background': '#f5f5f5' }}>

        <div className="tutorial-container">

          <IonCard className="tutorial-card">

            <IonCardContent>

              {/* Step indicator */}

              <div className="tutorial-step-indicator">

                Step {currentStep + 1} of {TUTORIAL_STEPS.length}

              </div>



              {/* Title */}

              <h2 className="tutorial-title">

                {currentStepData?.title || 'Welcome'}

              </h2>



              {/* Content */}

              <div className="tutorial-text">

                {currentStepData?.content ? (

                  currentStepData.content.split('\n\n').map((paragraph: string, index: number) => (

                    <p key={index}>{paragraph.trim()}</p>

                  ))

                ) : (

                  <p>No content available for this step.</p>

                )}

              </div>



              {/* Navigation buttons */}

              <div className="tutorial-navigation">

                <IonButton

                  fill="outline"

                  onClick={handleBack}

                  disabled={currentStep === 0}

                  className="tutorial-nav-button"

                >

                  <IonIcon slot="start" icon={arrowBack} />

                  Back

                </IonButton>



                <IonButton

                  fill="solid"

                  color="success"

                  onClick={handleNext}

                  className="tutorial-nav-button"

                >

                  {isLastStep ? "Let's Begin!" : 'Next'}

                  {!isLastStep && (

                    <IonIcon slot="end" icon={arrowForward} />

                  )}

                </IonButton>

              </div>



              {/* Step dots */}

              <div className="tutorial-dots">

                {TUTORIAL_STEPS.map((_: any, index: number) => (

                  <div

                    key={index}

                    className={`tutorial-dot ${index === currentStep ? 'active' : ''} ${

                      index < currentStep ? 'completed' : ''

                    }`}

                    onClick={() => setCurrentStep(index)}

                    role="button"

                    aria-label={`Go to step ${index + 1}`}

                  />

                ))}

              </div>

            </IonCardContent>

          </IonCard>

        </div>

      </IonContent>

    </IonModal>

  );

};



export default Tutorial;